import { createAsyncThunk } from '@reduxjs/toolkit';

import { driverAPI } from '@/modules/driver/api';
import { namespace } from '@/modules/driver/namespace';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { setDocDefinitions, setMyDriverDocDefinitions } from '../actions';

let lastRequestId: string | undefined;

const loadDriverDocDefinitions = createAsyncThunk(
  `${namespace}/fetch-doc-definitions`,
  async (_, { dispatch, requestId }): Promise<ThunkResult> => {
    try {
      if (lastRequestId !== undefined) {
        return { isAlreadyExecuted: true };
      }

      lastRequestId = requestId;

      const docs = await driverAPI.fetchDocDefinitions();
      const withoutPhoto = docs.filter(doc => doc.docType !== 'photo');

      dispatch(setDocDefinitions(withoutPhoto));
      dispatch(setMyDriverDocDefinitions(withoutPhoto));

      return { isSucceed: true };
    } finally {
      lastRequestId = undefined;
    }
  },
);

export { loadDriverDocDefinitions };
